import { FC } from 'react'

import { DataTrackingTypeHTMLElement } from '@hhgtech/hhg-components/types'
import { Box, BoxProps } from '@mantine/core'

import { MapIcons } from 'components/templates/carePath/landing/icons'
import { HeroBannerItem, SpotlightHeroBannerSession } from 'interfaces/types'

import { BannerItemProps } from './bannerItem'
import { HeroBannerContext } from './context'
import { CustomBanner } from './customLayout'
import { NavigatorProps } from './navigator'

export type HeroBannerProps = {
  sessionProps: SpotlightHeroBannerSession
  colorArr: string[]
  hasLeavePageConfirm?: boolean
  keepRatio?: boolean
  mappingIconList: MapIcons
  listBanner?: HeroBannerItem[]
  onBannerLoad?: () => void
  onItemClick?: (v: string) => void
  navigatorProps?: Partial<NavigatorProps>
  bannerTracking?: DataTrackingTypeHTMLElement
  bannerComponent?: FC<BannerItemProps>
  onClickRiskScreener?: () => void
  autoSlide?: boolean
  delayTime?: number
  hasSociaShare?: boolean
  ratio?: number
} & BoxProps

const HeroBanner = ({
  layout = CustomBanner,
  ...props
}: {
  layout?: FC<HeroBannerProps>
} & HeroBannerProps) => {
  const Layout = layout
  return (
    <HeroBannerContext.Provider value={{ ...props }}>
      <Box>
        <Layout {...props} />
      </Box>
    </HeroBannerContext.Provider>
  )
}

export { HeroBanner }
